<template>
  <div class="usr-task-box">
    <van-row>
      <van-col span="12" style="text-align: left"
        >今日充值 <span class="ycolor">{{ usrdata.sum }}</span></van-col
      >
      <van-col span="12" style="text-align: right"
        >今日有效投注 <span class="ycolor">{{ usrdata.bet }}</span></van-col
      >
    </van-row>
    <div class="box-list">
      <div style="height: 80px; position: relative; margin-top: 20px">
        <div
          style="
            border-top: 1px solid #c2bbc6;
            z-index: 1;
            position: absolute;
            z-index: 1;
            width: 98%;
            left: 0;
            top: 20px;
          "
        />
        <div style="display: flex; justify-content: flex-end">
          <div
            v-for="(item, index) in boxlist"
            :key="index"
            style="text-align: center; margin-left: 15px; z-index: 2"
            @click="openBox(item)"
          >
            <div :class="'box-item box-bg' + item.status" />
            {{ item.liveness }}
          </div>
        </div>
      </div>
    </div>
    <van-row>
      <van-col span="6" style="text-align: left"
        >活跃度 <span class="ycolor">{{ usrdata.liveness }}</span></van-col
      >
      <van-col span="18" style="text-align: right"
        ><div style="float: right">
          <div style="float: left">活跃度重置</div>
          <van-count-down
            style="width: 240px; color: #cca352 !important; margin-top: 4px"
            :time="time"
            format="DD 天 HH 时 mm 分 ss 秒"
          />
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'UsrBoxView',
  data () {
    return {
      usrdata: {},
      active: 1,
      time: 0,
      boxlist: []
    }
  },
  mounted () {
    this.GetTimeVal()
    this.GetUsrStats()
    this.GetUsrBox()
  },
  methods: {
    GetTimeVal () {
      const now = new Date()
      // 计算次日凌晨时间
      const midnight = new Date()
      midnight.setHours(24, 0, 0, 0)
      // 计算时间差（毫秒）
      this.time = midnight - now
    },
    async GetUsrStats () {
      await this.$http({
        method: 'get',
        url: 'usrStats'
      }).then(res => {
        this.usrdata = res.data
      })
    },
    async GetUsrBox () {
      await this.$http({
        method: 'post',
        url: 'usrBox'
      }).then(res => {
        this.boxlist = res.data
      })
    },
    async openBox (item) {

      if (item.status != 1) {
        this.$toast('打开后获得' + item.bonus_amount + '彩金，需要3倍流水可提现')

        return
      }
      await this.$http({
        method: 'get',
        url: 'doUsrBox',
        data: { id: item.id }
      }).then(res => {
        this.$toast.success(res.msg)
        this.GetUsrBox()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.usr-task-box {
  width: 90%;
  margin: 15px auto;
  padding: 10px;
  color: #fff;
  .box-list {
    text-align: left;
    margin: 10px auto;
    .box-item {
      width: 40px;
      height: 40px;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}
.box-bg0 {
  background-image: url('../../../assets/images/box/box.png');
  background-size: 56px auto;
}
.box-bg1 {
  background-image: url('../../../assets/images/box/box1.png');
  background-size: 100% auto;
}
.box-bg2 {
  background-image: url('../../../assets/images/box/box2.png');
  background-size: 100% auto;
}
.ycolor {
  color: rgb(204, 163, 82);
}
</style>
